<template>
  <!-- -->
  <div class="product-search mini-component">
    <div class="desc">
      商品搜索只是一个视觉插件，点击搜索框将跳转至搜索页面，本身不具有搜索功能。
    </div>
    <alone-data v-model="settingData" @change="changeData" :show-image="false" :show-tag="false" :show-background="false"/>
  </div>
</template>

<script>


import {watch} from "vue";
import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";

export default {
  emits: ["change"],
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    AloneData,
  },
  data() {
    return {
      settingData: {}
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {size: "", itemIcon: "iconfont_search"};
      } else {
        this.settingData = this.data.componentData;
      }
    },
    changeData() {
      this.$emit("change", {...this.data, componentData: this.settingData});
    }
  }
};
</script>

<style lang="scss" scoped>
.product-search{
}
</style>